import { useTranslation } from 'next-i18next';
import React from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

import { openModalForm } from '../../../redux/slices/showPhoneForm';
import { RootState } from '../../../redux/store';
import StyledButton from './DesktopStyledButton';
import StyledPhoneIcon from './StyledPhoneIcon';

const PhoneButton = ({ ...rest }) => {
  const dispatch = useDispatch();
  const disabled = useSelector(
    (state: RootState) => state.showPhoneForm.isShowPhoneButtonDisabled,
    shallowEqual
  );
  const handleClick = React.useCallback(() => {
    dispatch(openModalForm());
  }, [dispatch]);
  const { t } = useTranslation('property');
  return (
    <StyledButton
      variant='outlined'
      color='secondary'
      {...rest}
      disabled={disabled}
      onClick={handleClick}
    >
      {t('showPhone')}
      <StyledPhoneIcon />
    </StyledButton>
  );
};

export default PhoneButton;
